'use client'
import { useEffect } from 'react'

export default function useLockHTMLScroll({
  lockBodyClass = 'lock-scroll',
  stateOnWhichLockToggles,
}) {
  useEffect(() => {
    const htmlEl = document.querySelector('html')
    const lockHTMLScroll = () => htmlEl?.classList.add(lockBodyClass)
    const unLockHTMLScroll = () => htmlEl?.classList.remove(lockBodyClass)

    if (stateOnWhichLockToggles) {
      // make html not scrollable
      lockHTMLScroll()
    } else {
      unLockHTMLScroll()
    }

    return () => {
      // bring back scroll on unmount
      unLockHTMLScroll()
    }
  }, [stateOnWhichLockToggles, lockBodyClass])
}
